import "core-js/modules/es.array.slice.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "text-center mt-4"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("View more");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("View less");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Create a new one");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Try again");

var _hoisted_6 = {
  key: 1,
  class: "messages"
};
import { ref, computed } from "vue";
import { useUserStore } from "@/store/user";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import MessageItem from "@/components/messages/MessageItem.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    messages: {
      default: function _default() {
        return [];
      }
    },
    group: null,
    minimizable: {
      type: Boolean,
      default: false
    },
    minimizedMax: {
      default: 2
    },
    maxLines: {
      default: 3
    },
    showGroups: {
      type: Boolean,
      default: true
    },
    showPublic: {
      type: Boolean,
      default: true
    },
    loader: null,
    error: {
      default: "The requested data is currently inaccessible."
    }
  },
  emits: ["retry"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var userStore = useUserStore();
    var LoaderState = LoaderStateEnum;
    var minimized = ref(props.minimizable === true);
    var filtered = computed(function () {
      if (!props.minimizable || !minimized.value) {
        return props.messages;
      }

      var max = props.minimizedMax;
      return props.messages.slice(0, max);
    });
    var exceedMaximum = computed(function () {
      return props.minimizable && props.messages.length > props.minimizedMax;
    });
    return function (_ctx, _cache) {
      var _component_n_button = _resolveComponent("n-button");

      var _component_router_link = _resolveComponent("router-link");

      var _component_n_empty = _resolveComponent("n-empty");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      return __props.loader !== _unref(LoaderState).Loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.loader !== _unref(LoaderState).Failed ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.messages.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_TransitionGroup, {
        name: "list",
        tag: "div",
        class: "messages"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filtered), function (message) {
            var _unref$user;

            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["message-shape", {
                'is-user': _unref(userStore).authenticated && message.createdByUser.id === ((_unref$user = _unref(userStore).user) === null || _unref$user === void 0 ? void 0 : _unref$user.id)
              }]),
              key: message.messageId
            }, [_createVNode(MessageItem, {
              message: message,
              "max-lines": __props.maxLines,
              "show-groups": __props.showGroups,
              "show-public": __props.showPublic
            }, null, 8, ["message", "max-lines", "show-groups", "show-public"])], 2);
          }), 128))];
        }),
        _: 1
      }), _unref(exceedMaximum) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_button, {
        size: "small",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return minimized.value = !minimized.value;
        })
      }, {
        default: _withCtx(function () {
          return [minimized.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_hoisted_2], 64)) : _createCommentVNode("", true), !minimized.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_3], 64)) : _createCommentVNode("", true)];
        }),
        _: 1
      })])) : _createCommentVNode("", true)], 64)) : _renderSlot(_ctx.$slots, "empty", {
        key: 1
      }, function () {
        return [_createVNode(_component_n_empty, {
          description: "There isn't any messages yet."
        }, {
          extra: _withCtx(function () {
            var _props$group;

            return [_createVNode(_component_router_link, {
              to: {
                name: 'NewMessage',
                params: {
                  gid: (_props$group = __props.group) === null || _props$group === void 0 ? void 0 : _props$group.groupId
                }
              },
              class: "text-decoration-none"
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_n_button, {
                  type: "info"
                }, {
                  default: _withCtx(function () {
                    return [_hoisted_4];
                  }),
                  _: 1
                })];
              }),
              _: 1
            }, 8, ["to"])];
          }),
          _: 1
        })];
      })], 64)) : (_openBlock(), _createBlock(_component_n_result, {
        key: 1,
        status: "error",
        title: "Error",
        description: __props.error
      }, {
        footer: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return emit('retry');
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["description"]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(minimized.value ? __props.minimizedMax : 5, function (n) {
        return _openBlock(), _createElementBlock("div", {
          class: "message-shape",
          key: n
        }, [_createVNode(_component_n_skeleton, {
          class: "message-skeleton message-item rounded-2",
          sharp: false
        })]);
      }), 128))]));
    };
  }
});